import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components/macro';

import EmailInterstitialForm from './EmailInterstitialForm';
import {
    onSubscribeComplete,
    skipInterstitialPopup
} from '../../containers/Widget/actions';
import { CardTypes } from '../../utils/enums';
import { cacheFormData } from '../../utils/formCaching/actions';
import { copyFor } from '../../copy/copy';

import {
    AnimationContainer,
    Container,
    Body as BaseBody
} from '../Shared/PopupModalStyles';

const Body = styled(BaseBody)`
    height: auto;
    border: 1px solid #f1f1f1;

    @media (max-width: 30em) {
        width: calc(100% - 2em);
    }
`;

const EmailInterstitialPopup = props => (
    <AnimationContainer>
        <Container>
            <Body>
                <EmailInterstitialForm
                    onSubmit={values => {
                        props.cacheFormData(values);
                        props.onSubscribeComplete(
                            values,
                            props.activeAction.type,
                            props.activeAction.collectEmailFor,
                            props.isMultiActionsCard,
                            props.skipSuccessNavigation
                        );
                    }}
                    isEmailSubmitting={props.isEmailSubmitting}
                    skipInterstitialPopup={() =>
                        props.skipInterstitialPopup(
                            props.activeAction.type,
                            props.isMultiActionsCard,
                            props.skipSuccessNavigation
                        )
                    }
                    skipLinkVisible={props.skipLinkVisible}
                    collectEmailText={props.collectEmailText}
                />
            </Body>
        </Container>
    </AnimationContainer>
);

EmailInterstitialPopup.propTypes = {
    onSubscribeComplete: PropTypes.func.isRequired,
    isEmailSubmitting: PropTypes.bool,
    activeAction: PropTypes.object,
    skipInterstitialPopup: PropTypes.func,
    skipLinkVisible: PropTypes.bool,
    isMultiActionsCard: PropTypes.bool,
    skipSuccessNavigation: PropTypes.bool,
    collectEmailText: PropTypes.string,
    cacheFormData: PropTypes.func.isRequired
};

export default connect(
    state => ({
        isEmailSubmitting: state.widget.isEmailSubmitting,
        activeAction: state.widget.activeAction,
        skipLinkVisible: state.widget.activeAction.collectEmail === 1,
        isMultiActionsCard:
            state.widget.cards[state.widget.activeAction.order - 1].type ===
            CardTypes.multipleActions,
        collectEmailText:
            state.widget.activeAction.collectEmailText !== undefined
                ? state.widget.activeAction.collectEmailText
                : copyFor('emailInterstitial', 'collectEmailText')
    }),
    { onSubscribeComplete, skipInterstitialPopup, cacheFormData }
)(EmailInterstitialPopup);
